<mat-form-field class="bold-required-field">
  <mat-label>
    {{ fieldLabel }}
  </mat-label>
  <input
    *ngIf="isUppercase; else simpleInput"
    matInput
    controlValueToUpperCase
    type="inputType"
    [readonly]="isReadOnly"
    [formControl]="textFieldControl"
    [attr.test-id]="testId"
  />
  <ng-template #simpleInput>
    <input matInput type="inputType" [readonly]="isReadOnly" [formControl]="textFieldControl" />
  </ng-template>
  <mat-hint *ngIf="hintText" class="info-text">{{ hintText | translate }}</mat-hint>
  <mat-error>
    <ng-content></ng-content>
  </mat-error>
</mat-form-field>
